import { DamageType } from "../damageType";
import type { Direction } from "../direction";
import { ParticleEffect } from "../effects/particleEffect";
import type { ParticleEmitter } from "../interfaces";
import { Slugant } from "../mobs/slugant";
import { ParticleType } from "../particleType";
import type { PhysicalThingWithHp } from "../physicalThingWithHp";
import { STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import { ProjectileWithMaxRange } from "../projectileWithMaxRange";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { WeakMob } from "../weakMob";

export class SolidifierShot extends ProjectileWithMaxRange implements ParticleEmitter {
	static key = "SolidifierShot";

	private hitWeakMob: boolean = false;

	getParticleType(): ParticleType {
		return ParticleType.BUBBLE_TRAIL;
	}

	getMaxRange(): number {
		return 100;
	}

	protected damageTarget(target: PhysicalThingWithHp): number {
		if (target instanceof WeakMob || target instanceof Slugant) {
			this.hitWeakMob = true;
		}
		return target.applyDamage(DamageType.BUBBLE, STD_BASE_HP, this);
	}

	onHit(_damageDealt: number): void {
		this.board!.removeAtEndOfTurn(this);
		this.board!.addNonPhysicalThing(new Sound(SoundId.SOLIDIFYING, this.xy));
		const burstType = this.hitWeakMob ? ParticleType.SOLIDIFY_MOB_BURST : ParticleType.SOLIDIFY_BURST;
		const burstCount = this.hitWeakMob ? 16 : 10;
		this.board!.addEffect(new ParticleEffect(this.xy, burstType, burstCount));
	}

	onReachingMaxRange(): void {
		this.board!.addEffect(new ParticleEffect(this.xy, ParticleType.SOLIDIFY_BURST, 6));
		this.board!.removeAtEndOfTurn(this);
	}

	static deserialize(data: any): SolidifierShot {
		const shot = new SolidifierShot(deserializeXY(data.xy), data.direction as Direction);
		shot.visualId = data.visualId;
		shot.travelledDistance = data.travelledDistance;
		return shot;
	}
}
